import { render, staticRenderFns } from "./Rank.vue?vue&type=template&id=503412b5&scoped=true"
import script from "./Rank.vue?vue&type=script&lang=js"
export * from "./Rank.vue?vue&type=script&lang=js"
import style0 from "./Rank.vue?vue&type=style&index=0&id=503412b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503412b5",
  null
  
)

export default component.exports